/**
 * @generated SignedSource<<23a5d44997e95cbbb27887e9ce18c7fc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MessageDefinitionOverviewScreen_Query$variables = {
  numItemsPerPage: number;
};
export type MessageDefinitionOverviewScreen_Query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"MessageDefinitionOverviewScreen_PaginationFragment">;
};
export type MessageDefinitionOverviewScreen_Query = {
  response: MessageDefinitionOverviewScreen_Query$data;
  variables: MessageDefinitionOverviewScreen_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "numItemsPerPage"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "numItemsPerPage"
  },
  {
    "kind": "Literal",
    "name": "internalTitle",
    "value": ""
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MessageDefinitionOverviewScreen_Query",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "MessageDefinitionOverviewScreen_PaginationFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MessageDefinitionOverviewScreen_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminQueryType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MessagingAdminSchema",
            "kind": "LinkedField",
            "name": "Messaging",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "MessageDefinitionsConnection",
                "kind": "LinkedField",
                "name": "MessageDefinitions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MessageDefinitionsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MessageDefinition",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "internalTitle",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__id",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v1/*: any*/),
                "filters": [
                  "internalTitle"
                ],
                "handle": "connection",
                "key": "MessageDefinitionOverviewScreen_MessageDefinitions",
                "kind": "LinkedHandle",
                "name": "MessageDefinitions"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "87cbd9ce7643c67726ea7d7ca9e49d02",
    "id": null,
    "metadata": {},
    "name": "MessageDefinitionOverviewScreen_Query",
    "operationKind": "query",
    "text": "query MessageDefinitionOverviewScreen_Query(\n  $numItemsPerPage: Int!\n) {\n  ...MessageDefinitionOverviewScreen_PaginationFragment_35a4lq\n}\n\nfragment MessageDefinitionOverviewScreen_PaginationFragment_35a4lq on Query {\n  Admin {\n    Messaging {\n      MessageDefinitions(internalTitle: \"\", first: $numItemsPerPage) {\n        edges {\n          node {\n            id\n            internalTitle\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "adf9bb4a1c805bfa54e567ba7f541826";

export default node;
